const PersonalData = {
    firstName: "FireBrowser",
    lastName: "Devs",
    email:"firebrowserdevs@gmail.com",
    resumeLink:'#'
}
export const autoTypeData=['C#', 'V10', 'Uwp'];
export default PersonalData;